// Util
import { treatErrorAs } from 'api/errors';

// Constants
import { errorLevel } from 'constants/errors';

// finders
import { findAdvancedScriptAvailability } from 'advanced/finders';

// selectors
import { getActiveFieldUuid } from 'current/selectors';
import { canAdvancedScript } from 'product-features/selectors';

// util
import { ignorePollingAbort } from 'api/shared';

export const requestAdvancedScriptAvailability = () => {
  return (dispatch, getState) => {
    const state = getState();

    if (canAdvancedScript(state)) {
      const fieldUuid = getActiveFieldUuid(state);
      return findAdvancedScriptAvailability({ dispatch, getState, fieldUuid })
      .catch( ignorePollingAbort() )
      .catch( treatErrorAs({ severity: errorLevel.WARN, andHandleNow: true, message: 'find/process availability' }) );
    }
  };
};
